import React from 'react'
import { Link } from 'react-router-dom'
import HomeCarousel from '../../components/general/homepage/HomeCarousel'
import HomeInfo from '../../components/general/homepage/HomeInfo'
import HomeProjects from '../../components/general/homepage/HomeProjects'
import HomeWidePool from '../../components/general/homepage/HomeWidePool'
import HomeProfessionals from '../../components/general/homepage/HomeProfessionals'
import HomeSubscribe from '../../components/general/homepage/HomeSubscribe'
import HomePartners from '../../components/general/homepage/HomePartners'

const Homepage = () => {
	return (
		<>
			<main className='homepage'>
				<HomeCarousel />
				<HomeInfo />
				<HomeProjects />
				<HomeWidePool />
				<HomeProfessionals />
				<HomeSubscribe />
				<HomePartners />

				<section className='homepage_start'>
					<div className='container'>
						<div className='d-flex justify-content-center'>
							<div>
								<h1>
									Ready to work together?
									<span>
										<Link to='#' className='btn'>
											Start Campaign
										</Link>
									</span>
								</h1>
							</div>
						</div>
					</div>
				</section>
			</main>
		</>
	)
}

export default Homepage
